import PageToolBase from './page_tool';
import { focusStore } from '../store/nowFocusStore';
import { TOOLS } from '../toolbar/tools';
import { store } from '../../store';
import EventBus from '../event_bus';
export default class TouchMove extends PageToolBase {
    bookPage = null;
    startMove = false;
    startPosition = { x: 0, y: 0 };

    constructor(bookPage) {
        super();
        this.bookPage = bookPage;
    }

    onPointerDown(e) {
        this.bookPage.pageLoader.startMoveContainer(0);
        this.startPosition.x = e.clientX;
        this.startPosition.y = e.clientY;
    }

    onPointerMove(e) {
        if (!store.canTouchAction) return;
        if (focusStore.getSelectedObject()) return;
        if (this.startPosition.x == 0) {
            this.startPosition.x = e.clientX;
        }

        this.bookPage.move((e.clientX - this.startPosition.x), null);
        this.bookPage.$refs.animation_container.style.left = e.clientX - this.startPosition.x + 'px';
        this.bookPage.$refs.paintCanvas.style.left = e.clientX - this.startPosition.x + 'px';
    }

    onPointerUp(e) {
        store.canTouchAction = false;

        let offsetX = parseInt(this.bookPage.svgScaler.style.left.split('px')[0]) || 0;
        if (offsetX == 0) {
            store.nowTool = TOOLS.SELECTION.TOOL;
            return;
        }

        if (Math.abs(e.clientX - this.startPosition.x) > store.baseSize.width * 0.3) {
            if (e.clientX - this.startPosition.x > 0) {
                EventBus.getInstance().emit('go_left_page');
            }
            else {
                EventBus.getInstance().emit('go_right_page');
            }
        }

        this.bookPage.move(0, null);
        this.bookPage.$refs.animation_container.style.left = '0px';
        this.bookPage.$refs.paintCanvas.style.left = '0px';
        this.startPosition.x = 0;
        this.startPosition.y = 0;
        store.nowTool = TOOLS.SELECTION.TOOL;
    }
}